"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _formatters = require("../../../utils/formatters");
var _types = require("../../../utils/types");
var _ContactData = _interopRequireDefault(require("../../common/ContactData/ContactData"));
var _MailEditor = _interopRequireDefault(require("../../MailEditor/MailEditor"));
var _Mailcard = _interopRequireDefault(require("./Mailcard"));
var _ButtonAttached = _interopRequireDefault(require("../../ButtonAttached/ButtonAttached"));
var _helpers = require("../../../utils/helpers");
var _globalComponentsLibrary = require("global-components-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getName = function getName(url) {
  url = (0, _helpers.getLocation)(url, window.location.hostname, window.location.href);
  return url.substring(url.lastIndexOf('\\') + 1);
};
var Mail = function Mail(_ref) {
  var mail = _ref.mail,
    contact = _ref.contact,
    sender = _ref.sender,
    isOpen = _ref.isOpen,
    draft = _ref.draft,
    toggle = _ref.toggle,
    onReply = _ref.onReply,
    onAttachments = _ref.onAttachments,
    onUploadAttachments = _ref.onUploadAttachments,
    onDeleteAttachment = _ref.onDeleteAttachment,
    IsAzure = _ref.IsAzure,
    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
    onDeleteDraftMessage = _ref.onDeleteDraftMessage,
    onDialog = _ref.onDialog;
  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    editorOpen = _useState2[0],
    setEditorOpen = _useState2[1];
  var openEditor = function openEditor() {
    if (!isOpen) toggle();
    onDialog();
    setEditorOpen(true);
  };
  var editorDivRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (editorOpen) {
      var timer = setTimeout(function () {
        editorDivRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        });
      }, 500);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [editorOpen]);
  (0, _react.useEffect)(function () {
    setEditorOpen(false);
  }, [mail.id]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail",
    ref: editorDivRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-header"
  }, /*#__PURE__*/_react["default"].createElement(_ContactData["default"], contact), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-info"
  }, /*#__PURE__*/_react["default"].createElement("time", {
    dateTime: mail.date
  }, (0, _formatters.formatMailDate)(mail.date, i18n.language.slice(0, 2))), onReply && /*#__PURE__*/_react["default"].createElement("i", {
    id: 'uin-mail-reply-' + mail.id,
    className: "gcl-icon response",
    onClick: openEditor
  }), toggle && /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon chevron' + (isOpen ? '-up' : ''),
    onClick: toggle
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
    isOpen: isOpen,
    className: "uin-mail-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-content-wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-body"
  }, /*#__PURE__*/_react["default"].createElement(_Mailcard["default"], {
    contentHtml: mail.content
  })), mail.attachments && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-attachments"
  }, mail.attachments && mail.attachments.length > 1 && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    color: "secondary",
    onClick: onAttachments
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon download"
  }), t('downloadzip')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-attachments-wrapper"
  }, mail.attachments.map(function (m) {
    return /*#__PURE__*/_react["default"].createElement(_ButtonAttached["default"], {
      media: m,
      mediaName: getName(m)
    });
  }))), onReply && /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
    isOpen: editorOpen,
    className: "uin-mail-editor-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_MailEditor["default"], {
    key: mail.id,
    id: mail.id,
    to: {
      name: contact.name,
      account: contact.account
    },
    from: {
      name: sender.name,
      account: sender.account
    },
    originalMail: mail,
    onSend: onReply,
    onUpdateDraftMessage: onUpdateDraftMessage,
    onUpdateDraftAttachments: onUpdateDraftAttachments,
    draft: draft,
    onDiscard: function onDiscard() {
      return setEditorOpen(false);
    },
    onUploadAttachments: onUploadAttachments,
    onDeleteAttachment: onDeleteAttachment,
    onDeleteDraftMessage: onDeleteDraftMessage,
    IsAzure: IsAzure
  })))), onReply && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-mail-reply-' + mail.id
  }, t('reply')));
};
Mail.propType = {
  mail: _types.messageType,
  contact: _types.contactType,
  sender: _types.contactType,
  isOpen: _propTypes["default"].bool,
  toggle: _propTypes["default"].func,
  onReply: _propTypes["default"].func
};
Mail.defaultProps = {
  isOpen: true
};
var _default = exports["default"] = Mail;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/MailView/Mail.js
// module id = 1405
// module chunks = 0